<c-dropdown autoClose="outside" class="module-selector-wrapper" *ngIf="hasModules">
    <c-button cButton cDropdownToggle [caret]="false" variant="ghost" class="module-selector__button">
      <svg [cIcon]="icons.cibCoderwall"></svg>
    </c-button>
    <ul cDropdownMenu class="px-4 dropdown-menu" style="min-width: 460px;" class="module-selector-menu">
      <c-container>
        <h4 class="module-selector-menu__title">Telematics</h4>
        <c-row [gutter]="{g: 4}" class="align-items-start justify-content-star module-selector__row">
          <c-col class="d-flex flex-column module-selector__col" *ngFor="let module of allModules">
            <a href="{{module.url}}"  class="module-selector__link d-flex ">
              <img src="{{module.image}}" width="50" class="module-selector__image" alt="{{module.displayName}} module" />
              <span class="module-selector__label">{{module.name}}</span>
            </a>
           
          </c-col>

          <!-- <c-col class="d-flex flex-column module-selector__col">
            <img src="/assets/webicons/1x/1 Track It Icon.png" width="50" class="module-selector__image" />
            <span class="module-selector__label">Track Asset</span>
          </c-col>
          <c-col class="d-flex flex-column  module-selector__col">
            <img src="/assets/webicons/1x/2 Trace It Icon.png" width="50" />
            <span class="module-selector__label">Trace</span>
          </c-col>
          <c-col class="d-flex flex-column  module-selector__col">
            <img src="/assets/webicons/1x/2 Trace It Icon.png" width="50" />
            <span class="module-selector__label">Trace Vehicle</span>
          </c-col>
          <c-col class="d-flex flex-column  module-selector__col">
            <img src="/assets/webicons/1x/2 Trace It Icon.png" width="50" />
            <span class="module-selector__label">Timesheets</span>
          </c-col>
          <c-col class="d-flex flex-column  module-selector__col">
            <img src="/assets/webicons/1x/2 Trace It Icon.png" width="50" />
            <span class="module-selector__label">Trips/Stops</span>
          </c-col> -->
        </c-row>
      </c-container>
    </ul>
  </c-dropdown>
